var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { useApprovalWorkflow } from 'app/domains/approval';
import { useACLCan } from 'app/domains/filesystem/hooks/useACLCan';
import { ApproversDocumentAccessDocument } from './ApproversDocumentAccess.gql';
export const useApproverDocumentAccess = (userIds) => {
    const { documentId } = useApprovalWorkflow();
    const _a = useQuery(ApproversDocumentAccessDocument, {
        skip: !userIds.length,
        variables: { documentId, userIds },
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const { companyUsers = [], fileSystemEntry } = data || {};
    const isValidUser = (user) => Boolean(user === null || user === void 0 ? void 0 : user.userId);
    const users = companyUsers.filter(isValidUser).map((companyUser) => ({
        userId: companyUser.userId,
        role: companyUser.role,
    }));
    const userAcls = (fileSystemEntry === null || fileSystemEntry === void 0 ? void 0 : fileSystemEntry.acls) || [];
    const teamAcls = (fileSystemEntry === null || fileSystemEntry === void 0 ? void 0 : fileSystemEntry.teamAcls) || [];
    const { getAccessLevel } = useACLCan({ userAcls, teamAcls });
    const accessLevelMap = users.reduce((prev, user) => {
        const accessLevel = getAccessLevel(user.userId, user.role);
        return Object.assign(Object.assign({}, prev), { [user.userId]: accessLevel });
    }, {});
    const userIdsWithoutAccess = users
        .filter((user) => accessLevelMap[user.userId] === 'none')
        .map((user) => user.userId);
    return Object.assign({ userIdsWithoutAccess }, rest);
};
